<template lang="pug">
span.table-constructor-trigger-wrapper
  v-tooltip(bottom open-delay="200")
    template(#activator="{ on }")
      v-btn.table-constructor-trigger(
        :id="'table-constructor-' + tableKey"
        v-on="on"
        icon
        outlined
        color="primary"
        width="40"
        height="40"
        aria-label="Налаштувати таблицю"
        aria-haspopup="menu"
        aria-expanded="false"
        @click.stop
        @keydown.stop
      )
        v-icon(size="20") mdi-table-cog
    span Налаштувати таблицю
</template>

<script>
export default {
  name: 'TableConstructorButton',
  props: { tableKey: { type: String, required: true } }
}
</script>

<style lang="sass">
.table-constructor-trigger-wrapper
  display: inline-flex
  align-items: center
  flex: 0 0 auto

.table-constructor-trigger.v-btn
  padding: 0 !important
</style>
